import {
  type UserAttributesType
} from './Ambiguous'
import { LoadedUser } from './Loaded'

import { type UnloadedRole } from '../../../../Foobara/Auth/Types/Role/Unloaded'

import { type UnloadedDomain } from '../../../../Foobara/Commandforge/Types/Domain/Unloaded'

import { type UnloadedOrganization } from '../../../../Foobara/Commandforge/Types/Organization/Unloaded'

export interface UserAtomAttributesType extends UserAttributesType {
  id: number
  owned_organizations: UnloadedOrganization[]
  member_of_organizations: UnloadedOrganization[]
  owned_domains: UnloadedDomain[]
  member_of_domains: UnloadedDomain[]
  username?: string
  email?: string | null
  roles?: UnloadedRole[]
}

export class UserAtom extends LoadedUser<UserAtomAttributesType> {
  /* eslint-disable @typescript-eslint/class-literal-property-style */
  get isAtom (): true { return true }
  get isAggregate (): false { return false }
  /* eslint-enable @typescript-eslint/class-literal-property-style */
}
